export default {
  bookExperiencePanel: 'Панель бронирования опыта',
  calendarIcon: 'Иконка календаря',
  coverImageForResource: 'Обложка для опыта {{title}}',
  filterBy: 'Фильтр по {{filter}}',
  filterByDateRange: 'Фильтр по диапазону дат',
  gallery: 'Галерея',
  goBack: 'Назад к предыдущей странице',
  hostUserIcon: 'Иконка хоста',
  imageOf: 'Изображение {{title}}',
  interactiveMapAltText: 'Интерактивная карта с выбором {{title}}',
  mediaSlides: 'Медиа слайды',
  muteVideo: 'Отключить звук видео',
  nextPhoto: 'Следующее фото',
  noVideoPlayback: 'Нет возможности воспроизведения видео',
  pauseVideo: 'Пауза видео',
  photoOf: 'Фото {{name}}',
  playVideo: 'Воспроизвести видео',
  previousPhoto: 'Предыдущее фото',
  moreFiltersAndExperiences: 'Больше фильтров и впечатлений',
  reserveSelectedSlot: 'Забронировать выбранное время',
  reviewRating: 'Оценка отзыва {{rating}} из 5',
  overallReviewRating: 'Общая оценка отзывов {{rating}} из 5',
  selectCountryCodeForPhoneNumber: 'Выберите код страны для номера телефона',
  selectDate: 'Выберите дату',
  selectParticipants: 'Выберите участников',
  selectSessionTime: 'Выберите время сеанса',
  unmuteVideo: 'Включить звук видео',
  viewShoppingCart: 'Посмотреть корзину',
  itemsInCart: '{{count}} товаров в корзине',
  zoomIn: 'Увеличить',
  zoomOut: 'Уменьшить',
  selectData: 'Выберите {{data}}',
  reserveName: 'Забронировать {{name}}',
  deleteReservation: 'Удалить бронирование {{experienceTitle}}',
  editParticipantsFor: 'Редактировать участников для {{experienceTitle}}',
  increaseAddOnAmount: 'Увеличить выбранное {{addOn}}',
  decreaseAddOnAmount: 'Уменьшить выбранное {{addOn}}',
  addOnModal: '{{addOn}} модальное окно',
  moreInformationAboutAddOn: 'Больше информации о {{addOn}}',
  decreasePriceTierTickets: 'Уменьшить {{priceTier}} билеты',
  increasePriceTierTickets: 'Увеличить {{priceTier}} билеты',
  downloadFilename: 'Скачать {{filename}}',
  viewFullDetailsDescription: 'Просмотреть полное описание',
  viewFullDescription: 'Просмотреть полное описание',
  closeModal: 'Закрыть модальное окно',
  hyattBanner: 'Эксклюзивный баннер для участников World of Hyatt',
  hyattBannerDesc:
    'Рекламный баннер, указывающий на эксклюзивные преимущества и предложения для участников программы лояльности World of Hyatt',
  previousSlide: 'Предыдущий слайд',
  nextSlide: 'Следующий слайд',
  paginationBulletMessage: 'Перейти к слайду',
  exitFullscreen: 'Выйти из полноэкранного режима',
  enterFullscreen: 'Включить полноэкранный режим',
  videoSlide: 'Слайд видео',
  imageSlide: 'Слайд изображения',
  of: 'из',
  noDescription: 'Без описания',
  mediaGallery: 'Карусель - Медиа галерея',
  dateSelector: 'Выбор даты',
  nextWeek: 'Следующая неделя',
  previousWeek: 'Предыдущая неделя',
  scheduleAgenda: 'Расписание',
  scheduleNav: 'Навигация по расписанию',
  scheduleViewSelector: 'Выбор вида расписания',
  selectedDateAriaLabel: '{{date}}, выбрано',
  tapToBookExperience: 'Забронировать {{title}}',
  bookExperienceAriaLabel: 'Забронировать {{title}}',
  joinWaitlistAriaLabel: 'Записаться в лист ожидания на {{title}}',
};
